import { Inject, Injectable, Injector }from '@angular/core';

import { Discussions_DatasourceService } from './Discussions.datasource.index';
import { Utilities_DatasourceService } from './Utilities.datasource.index';
import { Addresses_DatasourceService } from './Addresses.datasource.index';
import { AsnOrders_DatasourceService } from './AsnOrders.datasource.index';
import { Attachments_DatasourceService } from './Attachments.datasource.index';
import { Carriers_DatasourceService } from './Carriers.datasource.index';
import { Instructions_DatasourceService } from './Instructions.datasource.index';
import { ExcelOrderImport_DatasourceService } from './ExcelOrderImport.datasource.index';
import { Locations_DatasourceService } from './Locations.datasource.index';
import { Lots_DatasourceService } from './Lots.datasource.index';
import { LoadContainers_DatasourceService } from './LoadContainers.datasource.index';
import { Owners_DatasourceService } from './Owners.datasource.index';
import { PurchaseOrders_DatasourceService } from './PurchaseOrders.datasource.index';
import { Invoices_DatasourceService } from './Invoices.datasource.index';
import { Notifications_DatasourceService } from './Notifications.datasource.index';
import { Materials_DatasourceService } from './Materials.datasource.index';
import { DockAppointments_DatasourceService } from './DockAppointments.datasource.index';
import { SerialNumbers_DatasourceService } from './SerialNumbers.datasource.index';
import { SalesOrders_DatasourceService } from './SalesOrders.datasource.index';
import { Inventory_DatasourceService } from './Inventory.datasource.index';

import { FootPrintPortalManager_TESTService } from './FootPrintPortalManager.datasource.index';
import { FootPrintPortalManager_ds_asn_order_editorService } from './FootPrintPortalManager.datasource.index';
import { FootPrintPortalManager_ds_asn_orders_tasks_gridService } from './FootPrintPortalManager.datasource.index';
import { FootPrintPortalManager_ds_dock_appointment_editorService } from './FootPrintPortalManager.datasource.index';
import { FootPrintPortalManager_ds_get_attachments_by_entityService } from './FootPrintPortalManager.datasource.index';
import { FootPrintPortalManager_ds_inbound_outbound_appointment_types_ddService } from './FootPrintPortalManager.datasource.index';
import { FootPrintPortalManager_ds_instructions_gridService } from './FootPrintPortalManager.datasource.index';
import { FootPrintPortalManager_ds_inventory_lot_gridService } from './FootPrintPortalManager.datasource.index';
import { FootPrintPortalManager_ds_inventory_material_gridService } from './FootPrintPortalManager.datasource.index';
import { FootPrintPortalManager_ds_inventory_pallet_gridService } from './FootPrintPortalManager.datasource.index';
import { FootPrintPortalManager_ds_inventory_tasks_gridService } from './FootPrintPortalManager.datasource.index';
import { FootPrintPortalManager_ds_inventory_transactions_gridService } from './FootPrintPortalManager.datasource.index';
import { FootPrintPortalManager_ds_invoices_gridService } from './FootPrintPortalManager.datasource.index';
import { FootPrintPortalManager_ds_lots_gridService } from './FootPrintPortalManager.datasource.index';
import { FootPrintPortalManager_ds_lots_grid_flat_flow_basedService } from './FootPrintPortalManager.datasource.index';
import { FootPrintPortalManager_ds_lots_grid_orphan_vendor_lotsService } from './FootPrintPortalManager.datasource.index';
import { FootPrintPortalManager_ds_operationcodes_ddService } from './FootPrintPortalManager.datasource.index';
import { FootPrintPortalManager_ds_order_dashboard_gridService } from './FootPrintPortalManager.datasource.index';
import { FootPrintPortalManager_ds_orderaddresses_gridService } from './FootPrintPortalManager.datasource.index';
import { FootPrintPortalManager_ds_orders_dashboardService } from './FootPrintPortalManager.datasource.index';
import { FootPrintPortalManager_ds_received_inventory_gridService } from './FootPrintPortalManager.datasource.index';
import { FootPrintPortalManager_ds_receiving_order_editorService } from './FootPrintPortalManager.datasource.index';
import { FootPrintPortalManager_ds_receiving_order_lines_gridService } from './FootPrintPortalManager.datasource.index';
import { FootPrintPortalManager_ds_receiving_orders_gridService } from './FootPrintPortalManager.datasource.index';
import { FootPrintPortalManager_ds_receiving_orders_tasks_gridService } from './FootPrintPortalManager.datasource.index';
import { FootPrintPortalManager_ds_serialnumbers_gridService } from './FootPrintPortalManager.datasource.index';
import { FootPrintPortalManager_ds_shipping_order_editorService } from './FootPrintPortalManager.datasource.index';
import { FootPrintPortalManager_ds_shipping_order_lines_gridService } from './FootPrintPortalManager.datasource.index';
import { FootPrintPortalManager_ds_shipping_orders_gridService } from './FootPrintPortalManager.datasource.index';
import { FootPrintPortalManager_ds_shipping_orders_tasks_gridService } from './FootPrintPortalManager.datasource.index';
import { FootPrintPortalManager_ds_shippingcontents_gridService } from './FootPrintPortalManager.datasource.index';

@Injectable({ providedIn: 'root' })
export class FootPrintPortalManager_DatasourceService {

  constructor(
    private injector: Injector
  ) {
    this.Discussions = this.injector.get(Discussions_DatasourceService);
    this.Utilities = this.injector.get(Utilities_DatasourceService);
    this.Addresses = this.injector.get(Addresses_DatasourceService);
    this.AsnOrders = this.injector.get(AsnOrders_DatasourceService);
    this.Attachments = this.injector.get(Attachments_DatasourceService);
    this.Carriers = this.injector.get(Carriers_DatasourceService);
    this.Instructions = this.injector.get(Instructions_DatasourceService);
    this.ExcelOrderImport = this.injector.get(ExcelOrderImport_DatasourceService);
    this.Locations = this.injector.get(Locations_DatasourceService);
    this.Lots = this.injector.get(Lots_DatasourceService);
    this.LoadContainers = this.injector.get(LoadContainers_DatasourceService);
    this.Owners = this.injector.get(Owners_DatasourceService);
    this.PurchaseOrders = this.injector.get(PurchaseOrders_DatasourceService);
    this.Invoices = this.injector.get(Invoices_DatasourceService);
    this.Notifications = this.injector.get(Notifications_DatasourceService);
    this.Materials = this.injector.get(Materials_DatasourceService);
    this.DockAppointments = this.injector.get(DockAppointments_DatasourceService);
    this.SerialNumbers = this.injector.get(SerialNumbers_DatasourceService);
    this.SalesOrders = this.injector.get(SalesOrders_DatasourceService);
    this.Inventory = this.injector.get(Inventory_DatasourceService);
  }

    public Discussions: Discussions_DatasourceService;
    public Utilities: Utilities_DatasourceService;
    public Addresses: Addresses_DatasourceService;
    public AsnOrders: AsnOrders_DatasourceService;
    public Attachments: Attachments_DatasourceService;
    public Carriers: Carriers_DatasourceService;
    public Instructions: Instructions_DatasourceService;
    public ExcelOrderImport: ExcelOrderImport_DatasourceService;
    public Locations: Locations_DatasourceService;
    public Lots: Lots_DatasourceService;
    public LoadContainers: LoadContainers_DatasourceService;
    public Owners: Owners_DatasourceService;
    public PurchaseOrders: PurchaseOrders_DatasourceService;
    public Invoices: Invoices_DatasourceService;
    public Notifications: Notifications_DatasourceService;
    public Materials: Materials_DatasourceService;
    public DockAppointments: DockAppointments_DatasourceService;
    public SerialNumbers: SerialNumbers_DatasourceService;
    public SalesOrders: SalesOrders_DatasourceService;
    public Inventory: Inventory_DatasourceService;
  public FootPrintPortalManager: FootPrintPortalManager_DatasourceService = this;

  // injecting lazily in order to avoid circular dependencies
  private _TEST: FootPrintPortalManager_TESTService;
  public get TEST(): FootPrintPortalManager_TESTService {
    if(!this._TEST) {
      this._TEST = this.injector.get(FootPrintPortalManager_TESTService);
    }
    return this._TEST;
  }
  private _ds_asn_order_editor: FootPrintPortalManager_ds_asn_order_editorService;
  public get ds_asn_order_editor(): FootPrintPortalManager_ds_asn_order_editorService {
    if(!this._ds_asn_order_editor) {
      this._ds_asn_order_editor = this.injector.get(FootPrintPortalManager_ds_asn_order_editorService);
    }
    return this._ds_asn_order_editor;
  }
  private _ds_asn_orders_tasks_grid: FootPrintPortalManager_ds_asn_orders_tasks_gridService;
  public get ds_asn_orders_tasks_grid(): FootPrintPortalManager_ds_asn_orders_tasks_gridService {
    if(!this._ds_asn_orders_tasks_grid) {
      this._ds_asn_orders_tasks_grid = this.injector.get(FootPrintPortalManager_ds_asn_orders_tasks_gridService);
    }
    return this._ds_asn_orders_tasks_grid;
  }
  private _ds_dock_appointment_editor: FootPrintPortalManager_ds_dock_appointment_editorService;
  public get ds_dock_appointment_editor(): FootPrintPortalManager_ds_dock_appointment_editorService {
    if(!this._ds_dock_appointment_editor) {
      this._ds_dock_appointment_editor = this.injector.get(FootPrintPortalManager_ds_dock_appointment_editorService);
    }
    return this._ds_dock_appointment_editor;
  }
  private _ds_get_attachments_by_entity: FootPrintPortalManager_ds_get_attachments_by_entityService;
  public get ds_get_attachments_by_entity(): FootPrintPortalManager_ds_get_attachments_by_entityService {
    if(!this._ds_get_attachments_by_entity) {
      this._ds_get_attachments_by_entity = this.injector.get(FootPrintPortalManager_ds_get_attachments_by_entityService);
    }
    return this._ds_get_attachments_by_entity;
  }
  private _ds_inbound_outbound_appointment_types_dd: FootPrintPortalManager_ds_inbound_outbound_appointment_types_ddService;
  public get ds_inbound_outbound_appointment_types_dd(): FootPrintPortalManager_ds_inbound_outbound_appointment_types_ddService {
    if(!this._ds_inbound_outbound_appointment_types_dd) {
      this._ds_inbound_outbound_appointment_types_dd = this.injector.get(FootPrintPortalManager_ds_inbound_outbound_appointment_types_ddService);
    }
    return this._ds_inbound_outbound_appointment_types_dd;
  }
  private _ds_instructions_grid: FootPrintPortalManager_ds_instructions_gridService;
  public get ds_instructions_grid(): FootPrintPortalManager_ds_instructions_gridService {
    if(!this._ds_instructions_grid) {
      this._ds_instructions_grid = this.injector.get(FootPrintPortalManager_ds_instructions_gridService);
    }
    return this._ds_instructions_grid;
  }
  private _ds_inventory_lot_grid: FootPrintPortalManager_ds_inventory_lot_gridService;
  public get ds_inventory_lot_grid(): FootPrintPortalManager_ds_inventory_lot_gridService {
    if(!this._ds_inventory_lot_grid) {
      this._ds_inventory_lot_grid = this.injector.get(FootPrintPortalManager_ds_inventory_lot_gridService);
    }
    return this._ds_inventory_lot_grid;
  }
  private _ds_inventory_material_grid: FootPrintPortalManager_ds_inventory_material_gridService;
  public get ds_inventory_material_grid(): FootPrintPortalManager_ds_inventory_material_gridService {
    if(!this._ds_inventory_material_grid) {
      this._ds_inventory_material_grid = this.injector.get(FootPrintPortalManager_ds_inventory_material_gridService);
    }
    return this._ds_inventory_material_grid;
  }
  private _ds_inventory_pallet_grid: FootPrintPortalManager_ds_inventory_pallet_gridService;
  public get ds_inventory_pallet_grid(): FootPrintPortalManager_ds_inventory_pallet_gridService {
    if(!this._ds_inventory_pallet_grid) {
      this._ds_inventory_pallet_grid = this.injector.get(FootPrintPortalManager_ds_inventory_pallet_gridService);
    }
    return this._ds_inventory_pallet_grid;
  }
  private _ds_inventory_tasks_grid: FootPrintPortalManager_ds_inventory_tasks_gridService;
  public get ds_inventory_tasks_grid(): FootPrintPortalManager_ds_inventory_tasks_gridService {
    if(!this._ds_inventory_tasks_grid) {
      this._ds_inventory_tasks_grid = this.injector.get(FootPrintPortalManager_ds_inventory_tasks_gridService);
    }
    return this._ds_inventory_tasks_grid;
  }
  private _ds_inventory_transactions_grid: FootPrintPortalManager_ds_inventory_transactions_gridService;
  public get ds_inventory_transactions_grid(): FootPrintPortalManager_ds_inventory_transactions_gridService {
    if(!this._ds_inventory_transactions_grid) {
      this._ds_inventory_transactions_grid = this.injector.get(FootPrintPortalManager_ds_inventory_transactions_gridService);
    }
    return this._ds_inventory_transactions_grid;
  }
  private _ds_invoices_grid: FootPrintPortalManager_ds_invoices_gridService;
  public get ds_invoices_grid(): FootPrintPortalManager_ds_invoices_gridService {
    if(!this._ds_invoices_grid) {
      this._ds_invoices_grid = this.injector.get(FootPrintPortalManager_ds_invoices_gridService);
    }
    return this._ds_invoices_grid;
  }
  private _ds_lots_grid: FootPrintPortalManager_ds_lots_gridService;
  public get ds_lots_grid(): FootPrintPortalManager_ds_lots_gridService {
    if(!this._ds_lots_grid) {
      this._ds_lots_grid = this.injector.get(FootPrintPortalManager_ds_lots_gridService);
    }
    return this._ds_lots_grid;
  }
  private _ds_lots_grid_flat_flow_based: FootPrintPortalManager_ds_lots_grid_flat_flow_basedService;
  public get ds_lots_grid_flat_flow_based(): FootPrintPortalManager_ds_lots_grid_flat_flow_basedService {
    if(!this._ds_lots_grid_flat_flow_based) {
      this._ds_lots_grid_flat_flow_based = this.injector.get(FootPrintPortalManager_ds_lots_grid_flat_flow_basedService);
    }
    return this._ds_lots_grid_flat_flow_based;
  }
  private _ds_lots_grid_orphan_vendor_lots: FootPrintPortalManager_ds_lots_grid_orphan_vendor_lotsService;
  public get ds_lots_grid_orphan_vendor_lots(): FootPrintPortalManager_ds_lots_grid_orphan_vendor_lotsService {
    if(!this._ds_lots_grid_orphan_vendor_lots) {
      this._ds_lots_grid_orphan_vendor_lots = this.injector.get(FootPrintPortalManager_ds_lots_grid_orphan_vendor_lotsService);
    }
    return this._ds_lots_grid_orphan_vendor_lots;
  }
  private _ds_operationcodes_dd: FootPrintPortalManager_ds_operationcodes_ddService;
  public get ds_operationcodes_dd(): FootPrintPortalManager_ds_operationcodes_ddService {
    if(!this._ds_operationcodes_dd) {
      this._ds_operationcodes_dd = this.injector.get(FootPrintPortalManager_ds_operationcodes_ddService);
    }
    return this._ds_operationcodes_dd;
  }
  private _ds_order_dashboard_grid: FootPrintPortalManager_ds_order_dashboard_gridService;
  public get ds_order_dashboard_grid(): FootPrintPortalManager_ds_order_dashboard_gridService {
    if(!this._ds_order_dashboard_grid) {
      this._ds_order_dashboard_grid = this.injector.get(FootPrintPortalManager_ds_order_dashboard_gridService);
    }
    return this._ds_order_dashboard_grid;
  }
  private _ds_orderaddresses_grid: FootPrintPortalManager_ds_orderaddresses_gridService;
  public get ds_orderaddresses_grid(): FootPrintPortalManager_ds_orderaddresses_gridService {
    if(!this._ds_orderaddresses_grid) {
      this._ds_orderaddresses_grid = this.injector.get(FootPrintPortalManager_ds_orderaddresses_gridService);
    }
    return this._ds_orderaddresses_grid;
  }
  private _ds_orders_dashboard: FootPrintPortalManager_ds_orders_dashboardService;
  public get ds_orders_dashboard(): FootPrintPortalManager_ds_orders_dashboardService {
    if(!this._ds_orders_dashboard) {
      this._ds_orders_dashboard = this.injector.get(FootPrintPortalManager_ds_orders_dashboardService);
    }
    return this._ds_orders_dashboard;
  }
  private _ds_received_inventory_grid: FootPrintPortalManager_ds_received_inventory_gridService;
  public get ds_received_inventory_grid(): FootPrintPortalManager_ds_received_inventory_gridService {
    if(!this._ds_received_inventory_grid) {
      this._ds_received_inventory_grid = this.injector.get(FootPrintPortalManager_ds_received_inventory_gridService);
    }
    return this._ds_received_inventory_grid;
  }
  private _ds_receiving_order_editor: FootPrintPortalManager_ds_receiving_order_editorService;
  public get ds_receiving_order_editor(): FootPrintPortalManager_ds_receiving_order_editorService {
    if(!this._ds_receiving_order_editor) {
      this._ds_receiving_order_editor = this.injector.get(FootPrintPortalManager_ds_receiving_order_editorService);
    }
    return this._ds_receiving_order_editor;
  }
  private _ds_receiving_order_lines_grid: FootPrintPortalManager_ds_receiving_order_lines_gridService;
  public get ds_receiving_order_lines_grid(): FootPrintPortalManager_ds_receiving_order_lines_gridService {
    if(!this._ds_receiving_order_lines_grid) {
      this._ds_receiving_order_lines_grid = this.injector.get(FootPrintPortalManager_ds_receiving_order_lines_gridService);
    }
    return this._ds_receiving_order_lines_grid;
  }
  private _ds_receiving_orders_grid: FootPrintPortalManager_ds_receiving_orders_gridService;
  public get ds_receiving_orders_grid(): FootPrintPortalManager_ds_receiving_orders_gridService {
    if(!this._ds_receiving_orders_grid) {
      this._ds_receiving_orders_grid = this.injector.get(FootPrintPortalManager_ds_receiving_orders_gridService);
    }
    return this._ds_receiving_orders_grid;
  }
  private _ds_receiving_orders_tasks_grid: FootPrintPortalManager_ds_receiving_orders_tasks_gridService;
  public get ds_receiving_orders_tasks_grid(): FootPrintPortalManager_ds_receiving_orders_tasks_gridService {
    if(!this._ds_receiving_orders_tasks_grid) {
      this._ds_receiving_orders_tasks_grid = this.injector.get(FootPrintPortalManager_ds_receiving_orders_tasks_gridService);
    }
    return this._ds_receiving_orders_tasks_grid;
  }
  private _ds_serialnumbers_grid: FootPrintPortalManager_ds_serialnumbers_gridService;
  public get ds_serialnumbers_grid(): FootPrintPortalManager_ds_serialnumbers_gridService {
    if(!this._ds_serialnumbers_grid) {
      this._ds_serialnumbers_grid = this.injector.get(FootPrintPortalManager_ds_serialnumbers_gridService);
    }
    return this._ds_serialnumbers_grid;
  }
  private _ds_shipping_order_editor: FootPrintPortalManager_ds_shipping_order_editorService;
  public get ds_shipping_order_editor(): FootPrintPortalManager_ds_shipping_order_editorService {
    if(!this._ds_shipping_order_editor) {
      this._ds_shipping_order_editor = this.injector.get(FootPrintPortalManager_ds_shipping_order_editorService);
    }
    return this._ds_shipping_order_editor;
  }
  private _ds_shipping_order_lines_grid: FootPrintPortalManager_ds_shipping_order_lines_gridService;
  public get ds_shipping_order_lines_grid(): FootPrintPortalManager_ds_shipping_order_lines_gridService {
    if(!this._ds_shipping_order_lines_grid) {
      this._ds_shipping_order_lines_grid = this.injector.get(FootPrintPortalManager_ds_shipping_order_lines_gridService);
    }
    return this._ds_shipping_order_lines_grid;
  }
  private _ds_shipping_orders_grid: FootPrintPortalManager_ds_shipping_orders_gridService;
  public get ds_shipping_orders_grid(): FootPrintPortalManager_ds_shipping_orders_gridService {
    if(!this._ds_shipping_orders_grid) {
      this._ds_shipping_orders_grid = this.injector.get(FootPrintPortalManager_ds_shipping_orders_gridService);
    }
    return this._ds_shipping_orders_grid;
  }
  private _ds_shipping_orders_tasks_grid: FootPrintPortalManager_ds_shipping_orders_tasks_gridService;
  public get ds_shipping_orders_tasks_grid(): FootPrintPortalManager_ds_shipping_orders_tasks_gridService {
    if(!this._ds_shipping_orders_tasks_grid) {
      this._ds_shipping_orders_tasks_grid = this.injector.get(FootPrintPortalManager_ds_shipping_orders_tasks_gridService);
    }
    return this._ds_shipping_orders_tasks_grid;
  }
  private _ds_shippingcontents_grid: FootPrintPortalManager_ds_shippingcontents_gridService;
  public get ds_shippingcontents_grid(): FootPrintPortalManager_ds_shippingcontents_gridService {
    if(!this._ds_shippingcontents_grid) {
      this._ds_shippingcontents_grid = this.injector.get(FootPrintPortalManager_ds_shippingcontents_gridService);
    }
    return this._ds_shippingcontents_grid;
  }
}

